import { Controller } from '@hotwired/stimulus'
import { removeFromCompareList } from '../utils/compare_storage'

/**
 * @file Крестик удаления ракетки из сравнения на странице результата (см.
 * compares/show.slim) — сама ссылка уже ведёт на URL без этого товара
 * (обычная навигация, тут её не перехватываем), контроллер только держит
 * localStorage-список (см. utils/compare_storage.js) в согласии с ней: на
 * собственной странице товара он больше не должен числиться "уже добавленным".
 */
export default class CompareRemoveController extends Controller {
  static values = { slug: String }

  remove() {
    removeFromCompareList(this.slugValue)
  }
}
